// extracted by mini-css-extract-plugin
export default {"wrapper":"clock_wrapper__J56b1","time":"clock_time__cVaT8"};